import React, { ReactNode } from 'react';
import { appRoutes } from '../../../../../path';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Banner, { BannerUI } from '../../../../../components/Banner';

interface IProps {
  baseId: string;
  message: ReactNode;
  buttonLabel: ReactNode;
}

const StyledBanner = styled(Banner)`
  margin-bottom: 8px;
  padding: 4px 16px;
  border-radius: 4px;
  font-size: 12px;
  min-height: 36px;
`;

const DashboardBanner = ({ baseId, message, buttonLabel }: IProps) => {
  return (
    <StyledBanner
      variant="info"
      rightSideComponent={
        <BannerUI.ButtonLink
          forwardedAs={Link}
          to={appRoutes.dashboard.generateLink(baseId)}
          isOutlined={true}
        >
          {buttonLabel}
        </BannerUI.ButtonLink>
      }
    >
      {message}
    </StyledBanner>
  );
};

export default DashboardBanner;
